module.exports = __webpack_public_path__ + "static/BrandonGrotesque-SemiBoldItalic-d6916c977e2e9bb31c3e80cd0d32470b.ttf";